import InputLabel from "@material-ui/core//InputLabel";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { withStyles } from "@material-ui/core/styles";
import InputMask from "react-input-mask";
import classes from "./SignUpPage.module.scss";
import React from "react";
import { useTranslation } from "react-i18next";

const GreenCheckbox = withStyles({
  root: {
    color: "#3f51b5",
    "&$checked": {
      color: "#3f51b5",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const SignUpTwo = ({
  handleChange,
  phone,
  phoneValidations,
  are_guideline_accepted,
  handleDecreaseSteps,
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={classes.inputRoot}>
      <div className={classes.buttonRootSecondary}>
        <Button
          variant="contained"
          className="btn btn-primary jr-btn-uptin"
          onClick={() => {
            handleDecreaseSteps();
          }}
          color="primary"
          // disabled={
          //   !phoneValidations || !passwordValidations || !are_guideline_accepted
          // }
        >
          {t("sign_up.sign_up_back_step_button")}
        </Button>
      </div>
      <InputMask
        // mask="99999999999"
        disabled={false}
        value={phone}
        // maskChar=" "
        onChange={(event) => handleChange(event)}
        formatChars={{ 9: "[0-9۰-۹]" }}
      >
        {() => (
          <div className={classes.outlinedInput} style={{ marginTop: "40px" }}>
            <FormControl variant="outlined">
              {/* <InputLabel>{t("sign_up.insert_phone_number")}</InputLabel> */}
              <OutlinedInput
                id="outlined-adornment-weight"
                name="phone"
                onChange={(event) => handleChange(event)}
                error={!phoneValidations}
                // startAdornment={
                //   <InputAdornment position="start" disablePointerEvents={true}>
                //     {t("sign_up.phone_number")}
                //   </InputAdornment>
                // }
                startAdornment={
                  i18n.language === "fa" && (
                    <InputAdornment
                      position="start"
                      disablePointerEvents={true}
                    >
                      {t("sign_up.phone_number")}
                    </InputAdornment>
                  )
                }
                endAdornment={
                  i18n.language === "en" && (
                    <InputAdornment position="end" disablePointerEvents={true}>
                      {t("sign_up.phone_number")}
                    </InputAdornment>
                  )
                }
              />
            </FormControl>
          </div>
          //   <TextField
          //     error={!phoneValidations}
          //     type="text"
          //     name="phone"
          //     label="تلفن همراه"
          //     margin="normal"
          //     className="mt-0 mb-3 app-login-form-mobile"
          //   />
        )}
      </InputMask>

      {/* <div className={classes.outlinedInput} style={{ marginTop: "40px" }}>
        <FormControl variant="outlined">
          <InputLabel>اگر شناسه معرف دارید در فیلد زیر وارد کنید</InputLabel>
          <OutlinedInput
            id="outlined-adornment-weight"
            name="merchant_code"
            onChange={(event) => handleChange(event)}
            error={!phoneValidations}
            defaultValue={merchant_code}
            startAdornment={
              <InputAdornment position="start">کد معرف</InputAdornment>
            }
          />
        </FormControl>
      </div> */}
      {/* <TextField
        type="text"
        label="کد معرف"
        onChange={(event) => handleChange(event)}
        name="merchant_code"
        defaultValue={merchant_code}
        margin="normal"
        className="mt-0 mb-2 app-login-form-first-name"
      /> */}
      <FormControlLabel
        className={
          i18n.language === "en" ? classes.checkboxLtr : classes.checkboxRtl
        }
        control={
          <GreenCheckbox
            checked={are_guideline_accepted}
            onChange={(event) => handleChange(event)}
            name="are_guideline_accepted"
          />
        }
        label={
          <span>
            {t("sign_up.contract")}
            <a href={"https://vkitaki.ir/fa/rules"}>{t("sign_up.accept")}</a>
          </span>
        }
      />
    </div>
  );
};

export default SignUpTwo;
